(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/personalization-settings-panel/personalization-settings-service.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/personalization-settings-panel/personalization-settings-service.js');
'use strict';

const {
  jupiter
} = svs.core;

const getCustomersSettingsAsync = async () => {
  svs.myProfile.logger.debug('PersonalizationSettingsService:getCustomersSettingsAsync start...');
  try {
    var _reply$response, _reply$response2;
    const reply = await jupiter.callAsync({
      method: 'GET',
      path: '/player/1/settings'
    });
    svs.myProfile.logger.debug('PersonalizationSettingsService:getCustomersSettingsAsync response from jupiter:', reply.response);
    return {
      error: (_reply$response = reply.response) === null || _reply$response === void 0 ? void 0 : _reply$response.error,
      settings: (_reply$response2 = reply.response) === null || _reply$response2 === void 0 ? void 0 : _reply$response2.settings
    };
  } catch (err) {
    svs.myProfile.logger.debug('PersonalizationSettingsService:getCustomersSettingsAsync error...');
    svs.myProfile.logger.warn(err);
    return {
      error: err,
      settings: {}
    };
  }
};

const putCustomersSettingsAsync = async settings => {
  try {
    const data = {
      settings: [settings]
    };
    const {
      response,
      status
    } = await jupiter.callAsync({
      method: 'PUT',
      path: '/player/1/settings',
      data
    });
    if (status !== 'success') {
      svs.myProfile.logger.warn('PersonalizationSettingsService:setCustomersSettingsAsync errer response from jupiter:', response.error);
      return {
        status,
        error: response.error
      };
    }
    svs.myProfile.logger.debug('PersonalizationSettingsService:setCustomersSettingsAsync response from jupiter:', response);
    return {
      status,
      error: response.error
    };
  } catch (err) {
    svs.myProfile.logger.warn(err);
    return {
      status: 'error',
      error: err
    };
  }
};
svs.myProfile.react.pages.communicationSettings.personalizationSettings.personalizationSettingsService = {
  putCustomersSettingsAsync,
  getCustomersSettingsAsync
};

 })(window);